import React from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { Provider } from 'react-redux'
import { legacy_createStore as createStore, compose, applyMiddleware } from 'redux'
import { createEpicMiddleware } from 'redux-observable'
import appriseApp, { appriseEpics } from './Redux/store'
import { loadState, saveState } from './Redux/localStorage'
import './Responsive.css'
import './App.css'
import './Wrappers/Wrappers.css'
import Logo from './Shared/Display/Logo'
import Delayed from './Wrappers/Delay'
import UserControls from './Wrappers/Interface/UserControls'
import NavWithRouter from './Wrappers/Interface/Nav'
import SessionExpired from './Shared/Display/SessionExpired'
import SendToken from './Wrappers/SendToken'
import Overview from './Wrappers/Overview'
import NewsFeed from './Wrappers/NewsFeed'
import ContentDetails from './Wrappers/ContentDetails'
import AdminDetails from './Wrappers/AdminDetails'
import UserDetails from './Wrappers/UserDetails'
import NotificationDetails from './Wrappers/NotificationDetails'
import AlertDetails from './Wrappers/AlertDetails'
import Administrator from './Wrappers/Administrator'
import Individual from './Wrappers/Individual'
import Other from './Wrappers/Other'
import Notifications from './Wrappers/Notifications'
import Search from './Wrappers/Search'
import SmsDetails from './Wrappers/SmsDetails'
import SmsHistory from './Wrappers/SmsHistory'

/** @const composeEnhancers */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

/** @func epicMiddleware */
const epicMiddleware = createEpicMiddleware()

/** @func persistedState */
const persistedState = loadState()

/** @func store */
export const store = createStore(appriseApp, persistedState,
  composeEnhancers(
    applyMiddleware(epicMiddleware)
  )
)

/** @func subscribe */
store.subscribe(() => {
  saveState({
    account: store.getState().account
  })
})

epicMiddleware.run(appriseEpics)

function App () {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <div id='topNav'>
          <Logo />
          <div id='headerTop'>
            <Delayed waitBeforeShow={500}>
              <Search />
            </Delayed>
            <UserControls />
          </div>
        </div>
        <div id='main'>
          <SessionExpired />
          <NavWithRouter />
          <div className='wrapper'>
            <Routes>
              <Route path='/admin' element={<Administrator />} />
              <Route path='/user-activity' element={<Individual />} />
              <Route path='/contents' element={<NewsFeed />} />
              <Route path='/other' element={<Other />} />
              <Route path='/dashboard' element={<Overview />} />
              <Route path='/user' element={<UserDetails />} />
              <Route path='/admindetails' element={<AdminDetails />} />
              <Route path='/content' element={<ContentDetails />} />
              <Route path='/alert' element={<AlertDetails />} />
              <Route path='/notifications' element={<Notifications />} />
              <Route path='/notification' element={<NotificationDetails />} />
              <Route path='/sms' element={<SmsDetails />} />
              <Route path='/sms-history' element={<SmsHistory />} />
              <Route path='/' element={<Navigate to='/dashboard' />} />
              <Route path='/access' element={(<SendToken><Navigate to='/' /></SendToken>)} />
            </Routes>
          </div>
        </div>
      </BrowserRouter>
    </Provider>
  )
}

export default App
